import useCustomHook from '@/hooks/useCustomHook';
import { ScrollContext } from '@/shared/KeepScroll/ScrollContext/ScrollContext';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

export default function useKeepScroll({ refs, keepIn }) {
  const scrollContext = useContext(ScrollContext);
  const router = useRouter();

  const { state, actions } = useCustomHook({
    defaultState: {
      navigating: false,
    },
    actions: {
      keepScroll: (scrollId) => {
        actions.setState({ navigating: true });
        scrollContext.actions.setScrollId(router.asPath, { scrollId, keepIn });
      },
    },
  });

  useEffect(() => {
    if (router.isReady) {
      if (!state.navigating) {
        const { scrollId } = scrollContext.state.scrollIds[router.asPath] || {};
        const element = refs.current[scrollId];
        if (scrollId && element) {
          const rect = element.getBoundingClientRect();
          const isBelowScreen = rect.top >= window.innerHeight;
          if (isBelowScreen && element.scrollIntoView) {
            element.scrollIntoView();
          }
          scrollContext.actions.setScrollId(router.asPath, null);
        }
      }
    }
  }, [
    refs.current,
    state.navigating,
    router.asPath,
    router.isReady,
    scrollContext.state.scrollIds,
  ]);

  return { state, actions };
}
